// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_containers_pgm {
  overflow: hidden;
  height: 100vh;
}
.details_containers_pgm .pgmcontainers_details {
  overflow: hidden;
}
.details_containers_pgm .pgmdetails_container {
  width: 100%;
  display: flex;
  overflow: hidden;
  height: 100vh;
}
.details_containers_pgm .flex-img-pgm {
  display: flex;
  gap: 10px;
}
.details_containers_pgm .page_minimize-pgm-details {
  float: right;
  margin: 2.4rem 1rem;
}
.details_containers_pgm .vehicle-sale-parts {
  display: flex;
  justify-content: space-between;
  width: 97%;
  margin: 0rem 1rem;
}
.details_containers_pgm .pgmdetails {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
}
.details_containers_pgm .pgm_details_container_s {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.details_containers_pgm .pgm_details_container_s::-webkit-scrollbar {
  width: 0px;
}
.details_containers_pgm .pgm_details_container_s::-webkit-scrollbar-thumb {
  background: transparent;
}
.details_containers_pgm .footer-div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.details_containers_pgm .sidebar {
  width: 20%;
}
.details_containers_pgm .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.details_containers_pgm .header_border > img {
  margin: 0.9rem 1rem;
}
.details_containers_pgm .pgmdetails_textbuttons {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
}
.details_containers_pgm .details_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #10132e;
}
.details_containers_pgm .pgmdetails_firstpara_text_Please {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: #ba1a1a;
  margin: 1rem;
}
.details_containers_pgm .checkbox {
  width: 20px;
  height: 20px;
}
.details_containers_pgm .details_close {
  width: 4.9rem;
  height: 1.8rem;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .details_approved {
  width: 5.7rem;
  height: 1.8rem;
  background: #00b55e;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .details_approved:disabled {
  width: 5.7rem;
  height: 1.8rem;
  background: #a7dbc3;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .details_need {
  width: 9.1rem;
  height: 1.8rem;
  background: #ba1a1a;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .details_need:disabled {
  width: 9.1rem;
  height: 1.8rem;
  background: #BA1A1A;
  border-radius: 5px;
  border: none;
  opacity: 0.2;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .pgmdetails_allbutoons {
  display: flex;
  gap: 1rem;
}
.details_containers_pgm .pgmdetails_firstpara {
  margin: 1rem;
  background: #f2f4ff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
}
.details_containers_pgm .pgmdetails_firstpara_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1.12rem;
  align-items: center;
  text-align: center;
  display: flex;
  gap: 1rem;
  color: #0c3688;
  padding: 1rem;
}
.details_containers_pgm [role=button] {
  cursor: pointer;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 1rem 0.5rem;
}
.details_containers_pgm .checkbox_div {
  display: flex;
  gap: 1rem;
}
.details_containers_pgm .pgm-details-pgmlist {
  word-spacing: 0.4rem;
}
.details_containers_pgm .checkbox_divs {
  display: flex;
  margin: 1rem;
  gap: 1rem;
}
.details_containers_pgm .checkbox_divs > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #0c3688;
}
.details_containers_pgm .googlemaptext {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  cursor: pointer;
  display: flex;
  gap: 0.4rem;
}
.details_containers_pgm .googlemaptext-bold {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0C3688;
  cursor: pointer;
  display: flex;
  gap: 0.4rem;
}
.details_containers_pgm .profile_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #0c3688;
  margin: 0rem 0.9rem;
}
.details_containers_pgm .profile_pgm_details {
  background: #f4f6fd;
  border-radius: 6px;
  margin: 1rem;
  display: flex;
  padding: 1rem 0rem;
}
.details_containers_pgm .profilepgm_profileicons {
  width: 20%;
  margin: 1rem;
}
.details_containers_pgm .profilepgm_profileicons .profile_img {
  height: 8rem;
  width: 8rem;
}
.details_containers_pgm .store-img {
  height: 8.812rem;
  width: 9.31rem;
  border: 1px;
  border-radius: 8px;
}
.details_containers_pgm .veryfication_images {
  border-radius: 5px;
  border: 1px;
  width: 13.68rem;
  height: 8.81rem;
}
.details_containers_pgm .profile_iconstext {
  width: 80%;
  border-left: 2px solid #ffffff;
}
.details_containers_pgm .Profile_icon_border {
  border-bottom: 2px solid #ffffff;
}
.details_containers_pgm .Profile_icon_text_spare {
  display: flex;
  justify-content: space-between;
  width: 60.5%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text_span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  color: #0c3688;
  gap: 1rem;
}
.details_containers_pgm .Profile_icon_text_para {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #32363f;
  display: flex;
  flex-direction: column;
}
.details_containers_pgm .Profile_icon_text_para-verficationid {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #32363f;
  display: flex;
  flex-direction: column;
  margin-left: 2.5rem;
}
.details_containers_pgm .Profilepgmdetails_email {
  margin: 1rem;
  display: flex;
  gap: 1rem;
}
.details_containers_pgm .pgm_details_parathird {
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem;
  display: flex;
  justify-content: space-between;
}
.details_containers_pgm .group-line-img {
  width: 85% !important;
}
.details_containers_pgm .select-group-btn {
  margin: 1rem 1rem;
  display: flex;
  align-items: center;
}
.details_containers_pgm .select-group-btn .select-group {
  width: 50%;
}
.details_containers_pgm .select-group-btn .select-group select {
  outline: none;
}
.details_containers_pgm .select-group-btn .save-btn button {
  background: #00B55E;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  border-radius: 5px;
  padding: 0.2rem 0.8rem;
  height: 2.5rem;
  width: 80px;
}
.details_containers_pgm .pgm_details_parathird > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  color: #0c3688;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.details_containers_pgm .questionary_label {
  position: relative;
  top: 25px;
  z-index: 1;
  left: 30px;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.details_containers_pgm .pgm_details_parathird > img {
  width: 31px;
  height: 31px;
  padding: 1rem;
}
.details_containers_pgm .pgm_details_parafourth {
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem;
}
.details_containers_pgm .pgm_details_parafourth_textspare {
  display: flex;
  justify-content: space-between;
  margin: 1px;
  width: 99%;
}
.details_containers_pgm .pgm_details_parafourth_textspare > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 0.7rem 0rem;
  display: flex;
  gap: 1rem;
  padding: 0.4rem;
}
.details_containers_pgm .pgm_details_parafourth_textsparespans {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #0c3688;
  margin: 1rem 0rem;
  display: flex;
  gap: 1rem;
  padding: 0.4rem;
}
.details_containers_pgm .pgm_details_parafourth_textspare > img {
  margin: 1rem 0rem;
}
.details_containers_pgm .pgm_details_parafive {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #0c3688;
  margin: 1rem;
}
.details_containers_pgm .pgmdetails_parasix {
  height: 49px;
  background: #f2f4ff;
  border-radius: 6px;
  margin: 1rem 0rem;
  width: 99%;
}
.details_containers_pgm .pgmdetails_sixspan {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #32363f;
  padding: 1rem;
  display: flex;
}
.details_containers_pgm .veryfication_border {
  background: #ffffff;
  border: 1px solid #a3aec4;
  border-radius: 5px;
}
.details_containers_pgm .veryfication_img {
  display: flex;
  flex-direction: column;
  margin: 1rem;
}
.details_containers_pgm .veryfication_id {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem;
}
.details_containers_pgm .pgm_details_sevenpara {
  display: flex;
  flex-wrap: wrap;
}
.details_containers_pgm .pgm_details_sevenparas {
  display: flex;
  margin: 1rem 0rem;
}
.details_containers_pgm .pgm_details_eight_paras {
  display: flex;
  gap: 1.5rem;
  margin: 2rem 0rem;
}
.details_containers_pgm .complete-address-pgmdetails {
  width: 90%;
}
.details_containers_pgm .veryfication_img > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #0c3688;
  display: flex;
  gap: 1rem;
  margin: 0rem 1rem;
}
.details_containers_pgm .veryfication_img > img {
  margin: 1rem 0.6rem;
}
.details_containers_pgm .commercial {
  margin-top: 8rem 0rem;
}
.details_containers_pgm .Profile_icon_text_organization {
  display: flex;
  justify-content: space-between;
  width: 72%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text_organization_records {
  display: flex;
  justify-content: space-between;
  width: 72%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text_records_businees {
  display: flex;
  justify-content: space-between;
  width: 80.5%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text_postal {
  display: flex;
  justify-content: space-between;
  width: 65.5%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text_province {
  display: flex;
  justify-content: space-between;
  width: 70.5%;
  margin: 1rem;
}
.details_containers_pgm .Profile_icon_text {
  display: flex;
  flex-wrap: wrap;
  width: 96%;
  margin: 1rem 1.4rem;
  padding: 0rem 0rem;
}
.details_containers_pgm .Profile_icon_text_profiledetails {
  display: flex;
  width: 70%;
  justify-content: space-between;
  margin: 1rem;
}
.details_containers_pgm .profile_commercial {
  width: 46%;
}
.details_containers_pgm .profile_commercials {
  width: 46%;
}
.details_containers_pgm .Pgm_Profile_details {
  display: flex;
  width: 100%;
}
.details_containers_pgm .Pgm_Profile_details > img {
  width: 85%;
}
.details_containers_pgm .Pgm_Profile_questionaire {
  display: flex;
  width: 100%;
}
.details_containers_pgm .Pgm_Profile_questionaire > img {
  width: 78%;
}
.details_containers_pgm .Pgm_Profile_businees {
  display: flex;
  width: 100%;
}
.details_containers_pgm .partnerspara_tens_span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
  padding: 1rem 0rem;
  margin: 1rem;
}
.details_containers_pgm .page_minimizes {
  float: right;
  right: 2.4rem;
  margin: 0rem -0.1rem;
}
.details_containers_pgm .page_minimize2s {
  float: right;
  right: 2.4rem;
  margin: 1.6rem 0.8rem;
}
.details_containers_pgm .partnerspara_tens > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #1445a4;
}
.details_containers_pgm .partnerspara_tens {
  width: 96%;
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #bcc6d7;
  border-bottom: 1px solid #bcc6d7;
  padding: 1rem 0rem;
}
.details_containers_pgm .Pgm_Profile_businees > img {
  width: 83%;
}
.details_containers_pgm .Pgm_Profile_verification {
  display: flex;
  width: 100%;
}
.details_containers_pgm .Pgm_Profile_verification > img {
  width: 87%;
}
.details_containers_pgm p {
  background: none;
}
.details_containers_pgm .pgmactive_button {
  background: #00B55E;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0rem 0.4rem;
  border-radius: 5px;
  padding: 0.2rem 0.8rem;
}
.details_containers_pgm .pgmInactive_button {
  background: #BA1A1A;
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0rem 0.4rem;
  border-radius: 5px;
  padding: 0.2rem 0.8rem;
}
.details_containers_pgm .change_role_button {
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding: 0rem 1rem;
  margin: 0.8rem 1rem;
  border-radius: 5px;
  white-space: nowrap;
  height: 2rem;
}
.details_containers_pgm .pgmdetails_role_box {
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  background: #f2f4ff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  align-items: center;
}
.details_containers_pgm .deactivate_button {
  width: 100%;
  height: 1.8rem;
  background: #ba1a1a;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .deactivate_button:disabled {
  width: 100%;
  height: 1.8rem;
  background: #f3cdcd;
  border-radius: 5px;
  border: none;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}
.details_containers_pgm .same_address_para {
  margin-left: 20px;
}

.popup-images {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-images .large-image {
  height: 69%;
  width: 50%;
}
.popup-images .cross-img {
  position: absolute;
  top: 17%;
  right: 26%;
  cursor: pointer;
}

@media screen and (max-width: 480px) {
  .details_containers_pgm .pgmdetails_container {
    width: 100%;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    height: 100vh;
  }
  .flex-img-pgm {
    flex-wrap: wrap;
  }
  .details_containers_pgm .sidebar {
    width: 100%;
  }
  .details_containers_pgm .pgm_details_container_s {
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
  }
  .details_containers_pgm .details_text {
    font-family: "Nunito";
    font-style: normal;
    font-weight: 600;
    font-size: 0.9rem;
    color: #10132e;
  }
  .details_containers_pgm .pgmdetails_firstpara_text_Please {
    font-family: "Nunito";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    color: #ba1a1a;
    margin: 1rem;
  }
  .details_containers_pgm .pgmdetails_textbuttons {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 1rem;
    gap: 1rem;
  }
  .details_containers_pgm .pgmdetails_firstpara_text_Please {
    display: flex;
    font-family: "Nunito";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    color: #ba1a1a;
    margin: 1rem;
  }
  .details_containers_pgm .pgmdetails_firstpara {
    margin: 1rem;
    background: #f2f4ff;
    border: 1px solid #c1c6d0;
    border-radius: 6px;
    display: flex;
    width: 90%;
  }
  .details_containers_pgm .profile_pgm_details {
    background: #f4f6fd;
    border-radius: 6px;
    margin: 1rem;
    display: flex;
    padding: 1rem 0rem;
    flex-direction: column;
  }
  .details_containers_pgm .Profile_icon_text_profiledetails {
    display: flex;
    width: 70%;
    flex-direction: column;
    margin: 1rem;
  }
  .details_containers_pgm .pgm_details_sevenpara {
    display: flex;
    flex-direction: column;
  }
  .details_containers_pgm .pgm_details_sevenparas {
    display: flex;
    margin: 1rem 0rem;
    flex-direction: column;
  }
  .details_containers_pgm {
    overflow: hidden;
    height: 100%;
  }
  .popupcontainers {
    box-sizing: border-box !important;
    background: #ffffff !important;
    border: 1px solid #aeb4c1 !important;
    border-radius: 6px !important;
    padding: 1rem !important;
    width: 100% !important;
    position: 0 !important;
    top: 0 !important;
    left: 0 !important;
  }
}
@media screen and (max-width: 768px) {
  .pgmdetails_container {
    flex-direction: column;
  }
  .details_containers_pgm .pgm_details_container_s {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PgmDetails/pgmdetails.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,SAAA;AADJ;AAIE;EACE,YAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;AAHJ;AAME;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;AAJJ;AAOE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EAUA,qBAAA;AAdJ;AAMI;EACE,UAAA;AAJN;AAOI;EACE,uBAAA;AALN;AAWE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AATJ;AAYE;EACE,UAAA;AAVJ;AAaE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAXJ;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAbJ;AAgBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAfJ;AAkBE;EACE,WAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,cAAA;EACA,mEAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AApBJ;AAuBE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AArBJ;AAwBE;EACE,aAAA;EACA,SAAA;AAtBJ;AAyBE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAvBJ;AA0BE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;AAxBJ;AA4BE;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,SAAA;AA3BJ;AA8BE;EACE,oBAAA;AA5BJ;AA+BE;EACE,aAAA;EACA,YAAA;EACA,SAAA;AA7BJ;AAgCE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AA/BJ;AAkCE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAhCJ;AAmCE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAjCJ;AAoCE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,UAAA;EACA,YAAA;AAnCJ;AAqCI;EACE,YAAA;EACA,WAAA;AAnCN;AAuCE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AArCJ;AAwCE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAtCJ;AAyCE;EACE,UAAA;EACA,8BAAA;AAvCJ;AA0CE;EACE,gCAAA;AAxCJ;AA2CE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AAzCJ;AA4CE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;AA1CJ;AA6CE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AA3CJ;AA8CE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,YAAA;EACA,aAAA;EACA,SAAA;AA7CJ;AAgDE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AA9CJ;AAiDE;EACE,qBAAA;AA/CJ;AAkDE;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;AAjDJ;AAmDI;EACE,UAAA;AAjDN;AAkDM;EACE,aAAA;AAhDR;AAqDM;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;AAnDR;AAwDE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAtDJ;AAyDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvDJ;AA0DE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAxDJ;AA2DE;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;AAzDJ;AA4DE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;AA1DJ;AA6DE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AA3DJ;AA8DE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AA5DJ;AA+DE;EACE,iBAAA;AA7DJ;AAgEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA9DJ;AAiEE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;AA/DJ;AAkEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;AAhEJ;AAmEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAjEJ;AAoEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlEJ;AAqEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAnEJ;AAsEE;EACE,aAAA;EACA,eAAA;AApEJ;AAuEE;EACE,aAAA;EACA,iBAAA;AArEJ;AAwEE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAtEJ;AAyEE;EACE,UAAA;AAvEJ;AA0EE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;AAxEJ;AA2EE;EACE,mBAAA;AAzEJ;AA4EE;EACE,qBAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AA3EJ;AA8EE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AA5EJ;AA+EE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AA7EJ;AAgFE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AA9EJ;AAiFE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;AA/EJ;AAkFE;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AAhFJ;AAmFE;EACE,aAAA;EACA,UAAA;EACA,8BAAA;EACA,YAAA;AAjFJ;AAoFE;EACE,UAAA;AAlFJ;AAqFE;EACE,UAAA;AAnFJ;AAsFE;EACE,aAAA;EACA,WAAA;AApFJ;AAuFE;EACE,UAAA;AArFJ;AAwFE;EACE,aAAA;EACA,WAAA;AAtFJ;AAyFE;EACE,UAAA;AAvFJ;AA0FE;EACE,aAAA;EACA,WAAA;AAxFJ;AA2FE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAzFJ;AA4FE;EACE,YAAA;EACA,aAAA;EACA,oBAAA;AA1FJ;AA6FE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;AA3FJ;AA+FE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA7FJ;AAgGE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;AA9FJ;AAiGE;EACE,UAAA;AA/FJ;AAkGE;EACE,aAAA;EACA,WAAA;AAhGJ;AAmGE;EACE,UAAA;AAjGJ;AAoGE;EACE,gBAAA;AAlGJ;AAoGE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAlGJ;AAoGE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAlGJ;AAoGE;EACE,mEAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAlGJ;AAoGE;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAlGJ;AAoGE;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlGJ;AAoGI;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAlGN;AAoGM;EACE,iBAAA;AAlGR;;AAuGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AApGF;AAsGE;EACE,WAAA;EACA,UAAA;AApGJ;AAsGE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AApGJ;;AAwGA;EACE;IACE,WAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;IACA,aAAA;EArGF;EAwGA;IACE,eAAA;EAtGF;EAyGA;IACE,WAAA;EAvGF;EA0GA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;EAxGF;EA2GA;IACE,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,cAAA;EAzGF;EA4GA;IACE,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EA1GF;EA6GA;IACE,aAAA;IACA,8BAAA;IACA,sBAAA;IACA,YAAA;IACA,SAAA;EA3GF;EA8GA;IACE,aAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;EA5GF;EA+GA;IACE,YAAA;IACA,mBAAA;IACA,yBAAA;IACA,kBAAA;IACA,aAAA;IACA,UAAA;EA7GF;EAgHA;IACE,mBAAA;IACA,kBAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,sBAAA;EA9GF;EAiHA;IACE,aAAA;IACA,UAAA;IACA,sBAAA;IACA,YAAA;EA/GF;EAkHA;IACE,aAAA;IACA,sBAAA;EAhHF;EAmHA;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;EAjHF;EAoHA;IACE,gBAAA;IACA,YAAA;EAlHF;EAqHA;IACE,iCAAA;IACA,8BAAA;IACA,oCAAA;IACA,6BAAA;IACA,wBAAA;IACA,sBAAA;IACA,sBAAA;IACA,iBAAA;IACA,kBAAA;EAnHF;AACF;AAsHA;EACE;IACE,sBAAA;EApHF;EAuHA;IACE,sBAAA;EArHF;AACF","sourcesContent":[".details_containers_pgm {\n  overflow: hidden;\n  height: 100vh;\n\n  .pgmcontainers_details {\n    overflow: hidden;\n  }\n\n  .pgmdetails_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n    height: 100vh;\n  }\n\n  .flex-img-pgm{\n    display: flex;\n    gap: 10px;\n  }\n\n  .page_minimize-pgm-details {\n    float: right;\n    margin: 2.4rem 1rem;\n  }\n\n  .vehicle-sale-parts {\n    display: flex;\n    justify-content: space-between;\n    width: 97%;\n    margin: 0rem 1rem;\n  }\n\n  .pgmdetails {\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 100vh;\n  }\n\n  .pgm_details_container_s {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 66px);\n\n    &::-webkit-scrollbar {\n      width: 0px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: transparent;\n    }\n\n    scrollbar-width: none;\n  }\n\n  .footer-div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .sidebar {\n    width: 20%;\n  }\n\n  .header_border {\n    background: #C0C8DA;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n\n  .header_border>img {\n    margin: 0.9rem 1rem;\n  }\n\n  .pgmdetails_textbuttons {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem;\n  }\n\n  .details_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.25rem;\n    color: #10132e;\n  }\n\n  .pgmdetails_firstpara_text_Please {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    color: #ba1a1a;\n    margin: 1rem;\n  }\n\n  .checkbox {\n    width: 20px;\n    height: 20px;\n  }\n\n  .details_close {\n    width: 4.9rem;\n    height: 1.8rem;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n\n  .details_approved {\n    width: 5.7rem;\n    height: 1.8rem;\n    background: #00b55e;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n\n  .details_approved:disabled {\n    width: 5.7rem;\n    height: 1.8rem;\n    background:#a7dbc3;;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n\n  .details_need {\n    width: 9.1rem;\n    height: 1.8rem;\n    background: #ba1a1a;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n\n  .details_need:disabled {\n    width: 9.1rem;\n    height: 1.8rem;\n    background: #BA1A1A;\n    border-radius: 5px;\n    border: none;\n    opacity: 0.2;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n  }\n\n  .pgmdetails_allbutoons {\n    display: flex;\n    gap: 1rem;\n  }\n\n  .pgmdetails_firstpara {\n    margin: 1rem;\n    background: #f2f4ff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n  }\n\n  .pgmdetails_firstpara_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1.12rem;\n    align-items: center;\n    text-align: center;\n    display: flex;\n    gap: 1rem;\n    color: #0c3688;\n    padding: 1rem;\n  }\n\n\n  [role=button] {\n    cursor: pointer;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 1rem 0.5rem;\n  }\n\n  .checkbox_div {\n    display: flex;\n    gap: 1rem;\n  }\n\n  .pgm-details-pgmlist {\n    word-spacing: 0.4rem;\n  }\n\n  .checkbox_divs {\n    display: flex;\n    margin: 1rem;\n    gap: 1rem;\n  }\n\n  .checkbox_divs>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #0c3688;\n  }\n\n  .googlemaptext {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    cursor: pointer;\n    display: flex;\n    gap: 0.4rem;\n  }\n\n  .googlemaptext-bold {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0C3688;\n    cursor: pointer;\n    display: flex;\n    gap: 0.4rem;\n  }\n\n  .profile_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0c3688;\n    margin: 0rem 0.9rem;\n  }\n\n  .profile_pgm_details {\n    background: #f4f6fd;\n    border-radius: 6px;\n    margin: 1rem;\n    display: flex;\n    padding: 1rem 0rem;\n  }\n\n  .profilepgm_profileicons {\n    width: 20%;\n    margin: 1rem;\n\n    .profile_img {\n      height: 8rem;\n      width: 8rem;\n    }\n  }\n\n  .store-img {\n    height: 8.812rem;\n    width: 9.31rem;\n    border: 1px;\n    border-radius: 8px;\n  }\n\n  .veryfication_images {\n    border-radius: 5px;\n    border: 1px;\n    width: 13.68rem;\n    height: 8.81rem;\n  }\n\n  .profile_iconstext {\n    width: 80%;\n    border-left: 2px solid #ffffff;\n  }\n\n  .Profile_icon_border {\n    border-bottom: 2px solid #ffffff;\n  }\n\n  .Profile_icon_text_spare {\n    display: flex;\n    justify-content: space-between;\n    width: 60.5%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text_span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex;\n    color: #0c3688;\n    gap: 1rem;\n  }\n\n  .Profile_icon_text_para {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #32363f;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .Profile_icon_text_para-verficationid {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #32363f;\n    display: flex;\n    flex-direction: column;\n    margin-left: 2.5rem;\n  }\n\n  .Profilepgmdetails_email {\n    margin: 1rem;\n    display: flex;\n    gap: 1rem;\n  }\n\n  .pgm_details_parathird {\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .group-line-img{\n    width: 85% !important;\n  }\n\n  .select-group-btn{\n    margin: 1rem 1rem;\n    // width: 50%;\n    display: flex;\n    align-items: center;\n\n    .select-group{\n      width: 50%;\n      select{\n        outline: none;\n      }\n    }\n\n    .save-btn{\n      button{\n        background: #00B55E;\n        font-family: Nunito;\n        font-size: 16px;\n        font-weight: 700;\n        color: #ffffff;\n        border-radius: 5px;\n        padding: 0.2rem 0.8rem;\n        height: 2.5rem;\n        width: 80px;\n      }\n    }\n  }\n\n  .pgm_details_parathird>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    display: flex;\n    color: #0c3688;\n    padding: 1rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n\n  .questionary_label {\n    position: relative;\n    top: 25px;\n    z-index: 1;\n    left: 30px;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n\n  .pgm_details_parathird>img {\n    width: 31px;\n    height: 31px;\n    padding: 1rem;\n  }\n\n  .pgm_details_parafourth {\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem;\n  }\n\n  .pgm_details_parafourth_textspare {\n    display: flex;\n    justify-content: space-between;\n    margin: 1px;\n    width: 99%;\n  }\n\n  .pgm_details_parafourth_textspare>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 0.7rem 0rem;\n    display: flex;\n    gap: 1rem;\n    padding: 0.4rem;\n  }\n\n  .pgm_details_parafourth_textsparespans {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #0c3688;\n    margin: 1rem 0rem;\n    display: flex;\n    gap: 1rem;\n    padding: 0.4rem;\n  }\n\n  .pgm_details_parafourth_textspare>img {\n    margin: 1rem 0rem;\n  }\n\n  .pgm_details_parafive {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #0c3688;\n    margin: 1rem;\n  }\n\n  .pgmdetails_parasix {\n    height: 49px;\n    background: #f2f4ff;\n    border-radius: 6px;\n    margin: 1rem 0rem;\n    width: 99%;\n  }\n\n  .pgmdetails_sixspan {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    color: #32363f;\n    padding: 1rem;\n    display: flex;\n  }\n\n  .veryfication_border {\n    background: #ffffff;\n    border: 1px solid #a3aec4;\n    border-radius: 5px;\n  }\n\n  .veryfication_img {\n    display: flex;\n    flex-direction: column;\n    margin: 1rem;\n  }\n\n  .veryfication_id {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin: 1rem;\n  }\n\n  .pgm_details_sevenpara {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .pgm_details_sevenparas {\n    display: flex;\n    margin: 1rem 0rem;\n  }\n\n  .pgm_details_eight_paras {\n    display: flex;\n    gap: 1.5rem;\n    margin: 2rem 0rem;\n  }\n\n  .complete-address-pgmdetails {\n    width: 90%;\n  }\n\n  .veryfication_img>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    color: #0c3688;\n    display: flex;\n    gap: 1rem;\n    margin: 0rem 1rem;\n  }\n\n  .veryfication_img>img {\n    margin: 1rem 0.6rem;\n  }\n\n  .commercial {\n    margin-top: 8rem 0rem;\n  }\n\n  .Profile_icon_text_organization {\n    display: flex;\n    justify-content: space-between;\n    width: 72%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text_organization_records {\n    display: flex;\n    justify-content: space-between;\n    width: 72%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text_records_businees {\n    display: flex;\n    justify-content: space-between;\n    width: 80.5%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text_postal {\n    display: flex;\n    justify-content: space-between;\n    width: 65.5%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text_province {\n    display: flex;\n    justify-content: space-between;\n    width: 70.5%;\n    margin: 1rem;\n  }\n\n  .Profile_icon_text {\n    display: flex;\n    flex-wrap: wrap;\n    width: 96%;\n    margin: 1rem 1.4rem;\n    padding: 0rem 0rem;\n  }\n\n  .Profile_icon_text_profiledetails {\n    display: flex;\n    width: 70%;\n    justify-content: space-between;\n    margin: 1rem;\n  }\n\n  .profile_commercial {\n    width: 46%;\n  }\n\n  .profile_commercials {\n    width: 46%;\n  }\n\n  .Pgm_Profile_details {\n    display: flex;\n    width: 100%;\n  }\n\n  .Pgm_Profile_details>img {\n    width: 85%;\n  }\n\n  .Pgm_Profile_questionaire {\n    display: flex;\n    width: 100%;\n  }\n\n  .Pgm_Profile_questionaire>img {\n    width: 78%;\n  }\n\n  .Pgm_Profile_businees {\n    display: flex;\n    width: 100%;\n  }\n\n  .partnerspara_tens_span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n    padding: 1rem 0rem;\n    margin: 1rem;\n  }\n\n  .page_minimizes {\n    float: right;\n    right: 2.4rem;\n    margin: 0rem -0.1rem;\n  }\n\n  .page_minimize2s {\n    float: right;\n    right: 2.4rem;\n    margin: 1.6rem 0.8rem;\n\n  }\n\n  .partnerspara_tens>span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1445a4;\n  }\n\n  .partnerspara_tens {\n    width: 96%;\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n    border-top: 1px solid #bcc6d7;\n    border-bottom: 1px solid #bcc6d7;\n    padding: 1rem 0rem;\n  }\n\n  .Pgm_Profile_businees>img {\n    width: 83%;\n  }\n\n  .Pgm_Profile_verification {\n    display: flex;\n    width: 100%;\n  }\n\n  .Pgm_Profile_verification>img {\n    width: 87%;\n  }\n\n  p {\n    background: none;\n  }\n  .pgmactive_button{\n    background: #00B55E;\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0rem 0.4rem;\n    border-radius: 5px;\n    padding: 0.2rem 0.8rem;\n  }\n  .pgmInactive_button{\n    background: #BA1A1A;\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0rem 0.4rem;\n    border-radius: 5px;\n    padding: 0.2rem 0.8rem;\n  }\n  .change_role_button{\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n    font-family: \"Nunito\";\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    padding: 0rem 1rem;\n    margin: 0.8rem 1rem;\n    border-radius: 5px;\n    white-space: nowrap;\n    height: 2rem;\n    }\n  .pgmdetails_role_box{\n    margin: 1rem;\n    display: flex;\n    justify-content: space-between;\n    background: #f2f4ff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n    align-items: center;\n    }\n  .deactivate_button {\n    width: 100%;\n    height: 1.8rem;\n    background:#ba1a1a;\n    border-radius: 5px;\n    border: none;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    color: #ffffff;\n    }\n    .deactivate_button:disabled {\n      width: 100%;\n      height: 1.8rem;\n      background:#f3cdcd;\n      border-radius: 5px;\n      border: none;\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 700;\n      font-size: 16px;\n      color: #ffffff;\n      }\n      .same_address_para{\n        margin-left: 20px;\n      }\n\n}\n\n.popup-images {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  \n  .large-image {\n    height: 69%;\n    width: 50%;\n  }\n  .cross-img {\n    position: absolute;\n    top: 17%;\n    right: 26%;\n    cursor: pointer;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .details_containers_pgm .pgmdetails_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n    height: 100vh;\n  }\n\n  .flex-img-pgm{\n    flex-wrap: wrap;\n  }\n\n  .details_containers_pgm .sidebar {\n    width: 100%;\n  }\n\n  .details_containers_pgm .pgm_details_container_s {\n    overflow-y: scroll;\n    overflow-x: hidden;\n    width: 100%;\n  }\n\n  .details_containers_pgm .details_text {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.9rem;\n    color: #10132e;\n  }\n\n  .details_containers_pgm .pgmdetails_firstpara_text_Please {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 17px;\n    color: #ba1a1a;\n    margin: 1rem;\n  }\n\n  .details_containers_pgm .pgmdetails_textbuttons {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    margin: 1rem;\n    gap: 1rem;\n  }\n\n  .details_containers_pgm .pgmdetails_firstpara_text_Please {\n    display: flex;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 17px;\n    color: #ba1a1a;\n    margin: 1rem;\n  }\n\n  .details_containers_pgm .pgmdetails_firstpara {\n    margin: 1rem;\n    background: #f2f4ff;\n    border: 1px solid #c1c6d0;\n    border-radius: 6px;\n    display: flex;\n    width: 90%;\n  }\n\n  .details_containers_pgm .profile_pgm_details {\n    background: #f4f6fd;\n    border-radius: 6px;\n    margin: 1rem;\n    display: flex;\n    padding: 1rem 0rem;\n    flex-direction: column;\n  }\n\n  .details_containers_pgm .Profile_icon_text_profiledetails {\n    display: flex;\n    width: 70%;\n    flex-direction: column;\n    margin: 1rem;\n  }\n\n  .details_containers_pgm .pgm_details_sevenpara {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .details_containers_pgm .pgm_details_sevenparas {\n    display: flex;\n    margin: 1rem 0rem;\n    flex-direction: column;\n  }\n\n  .details_containers_pgm {\n    overflow: hidden;\n    height: 100%;\n  }\n\n  .popupcontainers {\n    box-sizing: border-box !important;\n    background: #ffffff !important;\n    border: 1px solid #aeb4c1 !important;\n    border-radius: 6px !important;\n    padding: 1rem !important;\n    width: 100% !important;\n    position: 0 !important;\n    top: 0 !important;\n    left: 0 !important;\n  }\n}\n\n@media screen and (max-width : 768px) {\n  .pgmdetails_container {\n    flex-direction: column;\n  }\n\n  .details_containers_pgm .pgm_details_container_s {\n    width: 100% !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
